import RL from './route-literals';

export default {
  root: RL.root,
  signIn: `/${RL.signIn}`,
  home: `/${RL.home}`,
  signUp: `/${RL.signUp}`,
  dashboard: `/${RL.home}/${RL.dashboard}`,
  workflow: `/${RL.home}/${RL.workflow}`,
  account: `/${RL.account}`,
  myAccount: `/${RL.account}/${RL.myAccount}`,
  myAccountProfile: `/${RL.account}/${RL.myAccount}/${RL.profile}`,
  myAccountSignatures: `/${RL.account}/${RL.myAccount}/${RL.signatures}`,
  myAccountSecurity: `/${RL.myAccount}/${RL.security}`,
  provisions: `/${RL.provisions}`,
  provisionsSignatures: `/${RL.provisions}/${RL.signatures}`,
  provisionsStamps: `/${RL.provisions}/${RL.stamps}`,
  provisionsInvitations: `/${RL.provisions}/${RL.invitations}`,
  provisionsDocuments: `/${RL.provisions}/${RL.documents}`,
  documents: `/${RL.home}/${RL.documents}`,
  design: `/${RL.design}`,
  demo1: `/${RL.design}/${RL.demo1}`,
  demo2: `/${RL.design}/${RL.demo2}`,
  settings: `/${RL.settings}`,
  settings1: `/${RL.settings}/${RL.settings1}`,
  settings2: `/${RL.settings}/${RL.settings2}`,
  termsConditions: `/${RL.termsConditions}`,
  privacyPolicy: `/${RL.privacyPolicy}`,
  verifier: `/${RL.verifier}`,
};
